import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import IphoneIcon from 'src/icons/IphoneIcon'
import PatternIcon2 from 'src/icons/PatternIcon2'
import { ExtraLinks } from 'src/utils/extraLinks'

import Image from '../Image'
import Link from '../Link'

const MobileApp: React.FC = () => {
  return (
    <Stack
      sx={{
        position: 'relative',
        backgroundImage: 'url(/images/blue-bg.png)',
        backgroundSize: '105% 105%',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        minHeight: '725px',
        '@media (max-width: 590px)': {
          minHeight: '500px',
        },
      }}
      justifyContent="center"
      alignItems="center"
    >
      <Box
        component="div"
        sx={{
          position: 'relative',
          width: '100%',
          pointerEvents: 'none',
        }}
      >
        <PatternIcon2
          sx={{
            position: 'absolute',
            width: 340,
            height: 720,
            right: 0,
            translate: '0 -75%',
            pointerEvents: 'none',
            '@media (max-width: 590px)': {
              width: 260,
              height: 550,
              translate: '0 -74%',
            },
          }}
        />
      </Box>
      <Stack
        component="div"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          width: '70%',
          margin: (theme) => theme.spacing(0, 'auto'),
          '@media (max-width: 1000px)': {
            width: '100%',
            flexDirection: 'column',
          },
          '@media (max-width: 590px)': {
            width: '100%',
            px: 6,
            flexDirection: 'column',
          },
        }}
      >
        <Stack flex={0.1} sx={{
          zIndex: 10,
          '@media (max-width: 590px)': {
            flex: 'none',
            mb: 2,
          },
        }}>
          <IphoneIcon sx={{
            width: 582,
            height: 582,
            '@media (max-width: 590px)': {
              width: 200,
              height: 200,
            },
          }} />
        </Stack>
        <Stack
          component="div"
          sx={{
            height: '100% !important',
            maxWidth: '50%',
            zIndex: 10,
            '@media (max-width: 1000px)': {
              maxWidth: '90%',
            },
            '@media (max-width: 590px)': {
              maxWidth: '100%',
            },
          }}
          direction="column"
          alignItems="flex-start"
          flex={1}
          spacing={20}
        >
          <Typography
            sx={{
              fontSize: (theme) => theme.typography.fontSize * 4,
              fontWeight: 'bold',
              textAlign: 'left',
              color: 'bw.white',
              fontFamily: 'MetaProBold',
              '@media (max-width: 590px)': {
                fontSize: (theme) => theme.typography.fontSize * 2,
              },
            }}
          >
            Download the CSCS Smart Check app
          </Typography>
          <Typography sx={{
            textAlign: 'left',
            color: 'bw.white',
            maxWidth: '76%',
            '@media (max-width: 590px)': {
              maxWidth: '100%',
              fontSize: '14px',
            },
          }}>
            The CSCS Smart Check app allows all 2.1 million cards displaying the
            CSCS logo to be verified using a single interface, providing
            employers with a quick, easy and secure way of ensuring everyone has
            the right card for the job they do on site.
          </Typography>
          <Stack direction="row" spacing={10} justifyContent="center" sx={{
            '@media (max-width: 590px)': {
              gap: 2,
              width: '100%',
            },
          }}>
            <Link
              to={ExtraLinks.playStore}
              sx={{
                width: '160px',
                height: '50px',
                '@media (max-width: 590px)': {
                  width: '130px',
                  height: '40px',
                },
              }}
            >
              <Image src="/images/play-store.png" sx={{ objectFit: 'fill' }} />
            </Link>
            <Link
              to={ExtraLinks.appStore}
              sx={{
                width: '170px',
                height: '50px',
                '@media (max-width: 590px)': {
                  width: '130px',
                  height: '40px',
                },
              }}
            >
              <Image src="/images/app-store.png" sx={{ objectFit: 'fill' }} />
            </Link>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default MobileApp
